<!-- Update 01/04/22 -->
<div class="grid">
  <div class="col-12">
    <div class="card">
      <div class="grid">
        <div class="p-fluid grid formgrid ml-3 mt-4">
          <div class="field">
            <label class="font-bold">Seleccionar Rango de Fechas</label>
            <p-calendar
              #rangeDate
              [(ngModel)]="rangeDates"
              selectionMode="range"
              dateFormat="dd/mm/yy"
              dataType="date"
              placeholder="{{ 'Rango de Fechas' | translate }}"
              [readonlyInput]="true"
              [showIcon]="true"
              (onClearClick)="clearFilters()"
              (onSelect)="selectDateRange(rangeDate.value)"
            ></p-calendar>
          </div>
        </div>
        <div class="col-12">
         <!--  <dx-tree-map
            [dataSource]="items"
            [interactWithGroup]="true"
            [maxDepth]="2"
            [hoverEnabled]="true"
            [colorizer]="optionsColor"
            [loadingIndicator]="{ enabled: true, backgroundColor: '#FFFFFF' }"
            (onClick)="nodeClick($event)"
            (onDrill)="drill($event)"
          >
            <dxo-tooltip
              [enabled]="true"
              format="largeNumber"
              [customizeTooltip]="customizeTooltip"
            >
            </dxo-tooltip>
            <dxo-size [height]="440"></dxo-size>
            <dxo-title
              text="{{ 'Venta por Ubicaciones' | translate }}"
              [placeholderSize]="80"
            ></dxo-title>
            
            <dxo-export [enabled]="true"></dxo-export>
          </dx-tree-map> -->

          <div id="drill-down-title">
            <div class="grid">
              <div class="lg:col-12">
                <ol class="breadcrumb">
                  <li
                    *ngFor="
                      let drillInfo of drillInfos;
                      let isLast = last;
                      let i = index
                    "
                  >
                    <span *ngIf="i === 0">{{ drillInfo.text }}</span>
                    <span
                      *ngIf="i > 0"
                      [ngClass]="{ link: !!drillInfo.node }"
                      (click)="drillInfoClick(drillInfo.node)"
                      >{{ drillInfo.text }}</span
                    >
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
